<div class="contact-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Contact Us Section</h3>
    <button class="close-btn" (click)="onClose()" aria-label="Close panel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="segment-control">
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'content'"
        (click)="switchTab('content')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 6h12M3 10h12M3 14h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Content
      </button>
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'layout'"
        (click)="switchTab('layout')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="3" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    
    <!-- Heading & Paragraph Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('heading')" (click)="toggleSection('heading')">
      <div class="accordion-header">
        <h4 class="section-title">Heading & Paragraph</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('heading')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('heading')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Heading Input -->
        <div class="form-group">
          <label class="form-label">Heading</label>
          <app-text-editor
            [value]="data.title"
            [style]="data.titleStyle || {}"
            placeholder="Enter heading text..."
            (valueChange)="onHeadingChange($event)"
            (styleChange)="onHeadingStyleChange($event)">
          </app-text-editor>
        </div>

        <!-- Paragraph Input -->
        <div class="form-group">
          <label class="form-label">Paragraph</label>
          <textarea 
            class="paragraph-input"
            [value]="data.subtitle"
            (input)="onSubtitleChange($any($event.target).value)"
            placeholder="Enter paragraph text...">
          </textarea>
        </div>
      </div>
    </div>

    <!-- Map Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('map')" (click)="toggleSection('map')">
      <div class="accordion-header">
        <h4 class="section-title">Map</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('map')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('map')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Map Embed Link -->
        <div class="form-group">
          <label class="form-label">Map Embed Link</label>
          <textarea 
            class="form-textarea"
            [(ngModel)]="data.map!.embedLink"
            (ngModelChange)="onMapChange()"
            placeholder='<iframe src="https://www.google.co..."'
            rows="3"></textarea>
          
          <!-- Help Text -->
          <div class="help-text">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="info-icon">
              <circle cx="8" cy="8" r="7" stroke="#717683" stroke-width="1.5"/>
              <path d="M8 7v4M8 5h.01" stroke="#717683" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <div class="help-content">
              <strong>How to Get the Link</strong>
              <p>Get your embed link from Google Maps → Share → Embed a map → Copy HTML.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Details Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('contactDetails')" (click)="toggleSection('contactDetails')">
      <div class="accordion-header">
        <h4 class="section-title">Contact Details</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('contactDetails')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('contactDetails')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Location (Full Address) -->
        <div class="form-group">
          <label class="form-label">Location</label>
          <input 
            type="text"
            class="form-input"
            [value]="getFullAddress()"
            (input)="onFullAddressChange($event)"
            placeholder="1201 W. Caldwell Ave. Visalia, CA 93277"/>
        </div>

        <!-- Contact (Phone) -->
        <div class="form-group">
          <label class="form-label">Contact</label>
          <input 
            type="tel"
            class="form-input"
            [(ngModel)]="data.contactInfo!.phone"
            (ngModelChange)="onContactDetailsChange()"
            placeholder="(123) 456-7880"/>
        </div>

        <!-- Email -->
        <div class="form-group">
          <label class="form-label">Email</label>
          <input 
            type="email"
            class="form-input"
            [(ngModel)]="data.contactInfo!.email"
            (ngModelChange)="onContactDetailsChange()"
            placeholder="carwash@gmail.com"/>
        </div>

        <!-- Monday-Friday -->
        <div class="form-group">
          <label class="form-label">Monday- Friday <span class="label-suffix">(Operating Hours)</span></label>
          <input 
            type="text"
            class="form-input"
            [(ngModel)]="data.businessHours![0].openTime"
            (ngModelChange)="onContactDetailsChange()"
            placeholder="8:00 AM - 6:00 PM"/>
        </div>

        <!-- Saturday -->
        <div class="form-group">
          <label class="form-label">Saturday <span class="label-suffix">(Operating Hours)</span></label>
          <input 
            type="text"
            class="form-input"
            [(ngModel)]="data.businessHours![1].openTime"
            (ngModelChange)="onContactDetailsChange()"
            placeholder="8:00 AM - 5:00 PM"/>
        </div>

        <!-- Sunday -->
        <div class="form-group">
          <label class="form-label">Sunday <span class="label-suffix">(Operating Hours)</span></label>
          <input 
            type="text"
            class="form-input"
            [(ngModel)]="data.businessHours![2].openTime"
            (ngModelChange)="onContactDetailsChange()"
            placeholder="9:00 AM - 4:00 PM"/>
        </div>
      </div>
    </div>

    <!-- Background Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('background')" (click)="toggleSection('background')">
      <div class="accordion-header">
        <h4 class="section-title">Background</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('background')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('background')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#5E19A1'" (click)="onBackgroundColorChange('#5E19A1')">
              <div class="color-swatch" style="background-color: #5E19A1;"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Orange Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#FF9736'" (click)="onBackgroundColorChange('#FF9736')">
              <div class="color-swatch" style="background-color: #FF9736;"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Green Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#079271'" (click)="onBackgroundColorChange('#079271')">
              <div class="color-swatch" style="background-color: #079271;"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Blue Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#1B5BFF'" (click)="onBackgroundColorChange('#1B5BFF')">
              <div class="color-swatch" style="background-color: #1B5BFF;"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>

          </div>
          
          <!-- Divider -->
          <div class="color-divider"></div>
          
          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div class="color-item" 
               *ngFor="let customColor of customColors; trackBy: trackByIndex" 
               [class.selected]="data.backgroundColor === customColor" 
               (click)="openColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="color-picker-content">
        <chrome-picker 
          [(color)]="currentPickerColor"
          (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>
    </div>
  </div>

  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="layout-selector">
      <!-- Layout 1: Minimal Style -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '1'"
           (click)="onLayoutChange('1')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 1</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '1'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#FFFFFF'">
          <app-contact-layout-1-preview
            [data]="getContactLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()">
          </app-contact-layout-1-preview>
        </div>
      </div>

      <!-- Layout 2: Dark Style -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '2'"
           (click)="onLayoutChange('2')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 2</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '2'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#0D0E0F'">
          <app-contact-layout-2-preview
            [data]="getContactLayout2Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()">
          </app-contact-layout-2-preview>
        </div>
      </div>
    </div>
  </div>
</div>

